import Svg, { Path } from 'react-native-svg'
import type { SvgProps } from 'react-native-svg'

export function ChevronDown(props: SvgProps) {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        d="M6 9L11.2929 14.6854C11.6834 15.1049 12.3166 15.1049 12.7071 14.6854L18 9"
        stroke={props.color ?? '#131214'}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </Svg>
  )
}

export default ChevronDown
